// source: pbtypes/gen/skills/steering_joystick_handler_params.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.skills.SteeringJoystickHandlerParams', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.SteeringJoystickHandlerParams = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.SteeringJoystickHandlerParams, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.SteeringJoystickHandlerParams.displayName = 'proto.skills.SteeringJoystickHandlerParams';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.SteeringJoystickHandlerParams.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.SteeringJoystickHandlerParams.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.SteeringJoystickHandlerParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.SteeringJoystickHandlerParams.toObject = function(includeInstance, msg) {
  var f, obj = {
headingRateFilterTimeConstant: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
forwardSpeed: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
strafeSpeed: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
yawSpeed: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
fwdDzAtMaxYaw: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
fwdDzMin: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
fwdExpoValAtHalf: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
yawDzAtMaxFwd: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
yawDzMin: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
yawExpoValAtHalf: jspb.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
maxUpSpeed: jspb.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
maxDownSpeed: jspb.Message.getFloatingPointFieldWithDefault(msg, 12, 0.0),
yawButtonSpeed: jspb.Message.getFloatingPointFieldWithDefault(msg, 13, 0.0),
rightDzAtMaxFwd: jspb.Message.getFloatingPointFieldWithDefault(msg, 14, 0.0),
rightDzMin: jspb.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
rightExpoValAtHalf: jspb.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.SteeringJoystickHandlerParams}
 */
proto.skills.SteeringJoystickHandlerParams.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.SteeringJoystickHandlerParams;
  return proto.skills.SteeringJoystickHandlerParams.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.SteeringJoystickHandlerParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.SteeringJoystickHandlerParams}
 */
proto.skills.SteeringJoystickHandlerParams.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setHeadingRateFilterTimeConstant(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setForwardSpeed(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setStrafeSpeed(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setYawSpeed(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setFwdDzAtMaxYaw(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setFwdDzMin(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setFwdExpoValAtHalf(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setYawDzAtMaxFwd(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setYawDzMin(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setYawExpoValAtHalf(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxUpSpeed(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setMaxDownSpeed(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setYawButtonSpeed(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRightDzAtMaxFwd(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRightDzMin(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRightExpoValAtHalf(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.SteeringJoystickHandlerParams.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.SteeringJoystickHandlerParams.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.SteeringJoystickHandlerParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.SteeringJoystickHandlerParams.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHeadingRateFilterTimeConstant();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getForwardSpeed();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getStrafeSpeed();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getYawSpeed();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getFwdDzAtMaxYaw();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getFwdDzMin();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getFwdExpoValAtHalf();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getYawDzAtMaxFwd();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
  f = message.getYawDzMin();
  if (f !== 0.0) {
    writer.writeDouble(
      9,
      f
    );
  }
  f = message.getYawExpoValAtHalf();
  if (f !== 0.0) {
    writer.writeDouble(
      10,
      f
    );
  }
  f = message.getMaxUpSpeed();
  if (f !== 0.0) {
    writer.writeDouble(
      11,
      f
    );
  }
  f = message.getMaxDownSpeed();
  if (f !== 0.0) {
    writer.writeDouble(
      12,
      f
    );
  }
  f = message.getYawButtonSpeed();
  if (f !== 0.0) {
    writer.writeDouble(
      13,
      f
    );
  }
  f = message.getRightDzAtMaxFwd();
  if (f !== 0.0) {
    writer.writeDouble(
      14,
      f
    );
  }
  f = message.getRightDzMin();
  if (f !== 0.0) {
    writer.writeDouble(
      15,
      f
    );
  }
  f = message.getRightExpoValAtHalf();
  if (f !== 0.0) {
    writer.writeDouble(
      16,
      f
    );
  }
};


/**
 * optional double heading_rate_filter_time_constant = 1;
 * @return {number}
 */
proto.skills.SteeringJoystickHandlerParams.prototype.getHeadingRateFilterTimeConstant = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.SteeringJoystickHandlerParams} returns this
 */
proto.skills.SteeringJoystickHandlerParams.prototype.setHeadingRateFilterTimeConstant = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double forward_speed = 2;
 * @return {number}
 */
proto.skills.SteeringJoystickHandlerParams.prototype.getForwardSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.SteeringJoystickHandlerParams} returns this
 */
proto.skills.SteeringJoystickHandlerParams.prototype.setForwardSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double strafe_speed = 3;
 * @return {number}
 */
proto.skills.SteeringJoystickHandlerParams.prototype.getStrafeSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.SteeringJoystickHandlerParams} returns this
 */
proto.skills.SteeringJoystickHandlerParams.prototype.setStrafeSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double yaw_speed = 4;
 * @return {number}
 */
proto.skills.SteeringJoystickHandlerParams.prototype.getYawSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.SteeringJoystickHandlerParams} returns this
 */
proto.skills.SteeringJoystickHandlerParams.prototype.setYawSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double fwd_dz_at_max_yaw = 5;
 * @return {number}
 */
proto.skills.SteeringJoystickHandlerParams.prototype.getFwdDzAtMaxYaw = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.SteeringJoystickHandlerParams} returns this
 */
proto.skills.SteeringJoystickHandlerParams.prototype.setFwdDzAtMaxYaw = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double fwd_dz_min = 6;
 * @return {number}
 */
proto.skills.SteeringJoystickHandlerParams.prototype.getFwdDzMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.SteeringJoystickHandlerParams} returns this
 */
proto.skills.SteeringJoystickHandlerParams.prototype.setFwdDzMin = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double fwd_expo_val_at_half = 7;
 * @return {number}
 */
proto.skills.SteeringJoystickHandlerParams.prototype.getFwdExpoValAtHalf = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.SteeringJoystickHandlerParams} returns this
 */
proto.skills.SteeringJoystickHandlerParams.prototype.setFwdExpoValAtHalf = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double yaw_dz_at_max_fwd = 8;
 * @return {number}
 */
proto.skills.SteeringJoystickHandlerParams.prototype.getYawDzAtMaxFwd = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.SteeringJoystickHandlerParams} returns this
 */
proto.skills.SteeringJoystickHandlerParams.prototype.setYawDzAtMaxFwd = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};


/**
 * optional double yaw_dz_min = 9;
 * @return {number}
 */
proto.skills.SteeringJoystickHandlerParams.prototype.getYawDzMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.SteeringJoystickHandlerParams} returns this
 */
proto.skills.SteeringJoystickHandlerParams.prototype.setYawDzMin = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional double yaw_expo_val_at_half = 10;
 * @return {number}
 */
proto.skills.SteeringJoystickHandlerParams.prototype.getYawExpoValAtHalf = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 10, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.SteeringJoystickHandlerParams} returns this
 */
proto.skills.SteeringJoystickHandlerParams.prototype.setYawExpoValAtHalf = function(value) {
  return jspb.Message.setProto3FloatField(this, 10, value);
};


/**
 * optional double max_up_speed = 11;
 * @return {number}
 */
proto.skills.SteeringJoystickHandlerParams.prototype.getMaxUpSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 11, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.SteeringJoystickHandlerParams} returns this
 */
proto.skills.SteeringJoystickHandlerParams.prototype.setMaxUpSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 11, value);
};


/**
 * optional double max_down_speed = 12;
 * @return {number}
 */
proto.skills.SteeringJoystickHandlerParams.prototype.getMaxDownSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 12, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.SteeringJoystickHandlerParams} returns this
 */
proto.skills.SteeringJoystickHandlerParams.prototype.setMaxDownSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 12, value);
};


/**
 * optional double yaw_button_speed = 13;
 * @return {number}
 */
proto.skills.SteeringJoystickHandlerParams.prototype.getYawButtonSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 13, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.SteeringJoystickHandlerParams} returns this
 */
proto.skills.SteeringJoystickHandlerParams.prototype.setYawButtonSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 13, value);
};


/**
 * optional double right_dz_at_max_fwd = 14;
 * @return {number}
 */
proto.skills.SteeringJoystickHandlerParams.prototype.getRightDzAtMaxFwd = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 14, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.SteeringJoystickHandlerParams} returns this
 */
proto.skills.SteeringJoystickHandlerParams.prototype.setRightDzAtMaxFwd = function(value) {
  return jspb.Message.setProto3FloatField(this, 14, value);
};


/**
 * optional double right_dz_min = 15;
 * @return {number}
 */
proto.skills.SteeringJoystickHandlerParams.prototype.getRightDzMin = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 15, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.SteeringJoystickHandlerParams} returns this
 */
proto.skills.SteeringJoystickHandlerParams.prototype.setRightDzMin = function(value) {
  return jspb.Message.setProto3FloatField(this, 15, value);
};


/**
 * optional double right_expo_val_at_half = 16;
 * @return {number}
 */
proto.skills.SteeringJoystickHandlerParams.prototype.getRightExpoValAtHalf = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 16, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.SteeringJoystickHandlerParams} returns this
 */
proto.skills.SteeringJoystickHandlerParams.prototype.setRightExpoValAtHalf = function(value) {
  return jspb.Message.setProto3FloatField(this, 16, value);
};


goog.object.extend(exports, proto.skills);
